export const routeDataBeforeLogin = [

  ];